<template lang="pug">
	modal(max-width="400")
		.card.text-left
			.card-header.bg-danger.text-white
				span.fa.fa-ban.mr-2
				| Cita cancelada
				button.close(@click="cerrar") &times;
			.card-body
				h5 Datos de la cancelación
				hr
				.form-group
					label ¿Quien ha cancelado la cita?
					br
					.btn-group
						button.btn(:class="(form.quien_cancela === 'cliente') ? 'btn-primary' : ''", @click="setQuien('cliente')") Cliente
						button.btn(:class="(form.quien_cancela === 'agente') ? 'btn-primary' : ''", @click="setQuien('agente')") Agente
				.form-group
					label Motivos de la cancelación
					textarea.form-control(placeholder="Por favor especifica los motivos por los que se ha cancelado la cita", v-model="form.motivos_cancelacion", rows="4")
			.card-footer
				button.btn.btn-primary(@click="cancelar")
					span.fa.fa-ban.mr-2
					| Registrar cancelación
</template>

<script>
import axios from 'axios'

export default {
	props: ['idEntrada'],
	data () {
		return {
			form: {
				quien_cancela: 'cliente',
				motivos_cancelacion: ''
			}
		}
	},

	methods: {
		cerrar () {
			this.$emit('cerrar')
		},

		setQuien (quien) {
			this.form.quien_cancela = quien
		},

		cancelar () {
			const datos = {
				quien_cancela: this.form.quien_cancela,
				motivos_cancelacion: this.form.motivos_cancelacion,
				ID_entrada: this.idEntrada
			}
			axios.post('/agenda-comercial/php/api/set-entrada-cancelada.php', datos)
				.then(() => {
					this.$emit('cancelada')
					this.$store.commit('toast/success', {
						titulo: 'Cita cancelada',
						mensaje: 'Se ha marcado la cita como cancelada'
					})
				})
				.catch(this.$responseError)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/agenda-comercial/vue/componentes/editor/cancelar.vue